import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=1ae9411c&"
import script from "./app-footer.vue?vue&type=script&lang=js&"
export * from "./app-footer.vue?vue&type=script&lang=js&"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=1ae9411c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports